import { Tooltip as PRTooltip } from "primereact/tooltip";
import { type TooltipProps } from "./tooltip.interface";

export const Tooltip = (props: TooltipProps) => {
	return <PRTooltip {...props} />;
};
